import { App, Plugin } from 'vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export const ToastPlugin: Plugin<void> = {
  install(app: App) {
    app.use(Toast, {
      maxToasts: 3,
    });
  },
};
